// The dashboard client ENTRY. esbuild bundles this into a single client script the monolith serves. It
// imports the ONE stylesheet (Tailwind + governed tokens) and mounts the React app into the shell root.
//
// No business logic here — the entry parses nothing and calls no domain service; it wires React to the DOM.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import './styles/index.css';

const container = document.getElementById('ritona-root');
if (container === null) {
  // Fail honestly and visibly if the shell root is missing — no silent no-op.
  throw new Error('dashboard client: #ritona-root mount point not found in the served shell');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
